import { apiBaseUrl } from 'constants/apiBaseUrl'
import { getAuthToken } from 'core/api/axiosClient'

export type AssistantMemoryNote = {
  id: string
  text: string
  createdAt: string
}

async function authHeaders(): Promise<HeadersInit> {
  const token = await getAuthToken()
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }
}

export async function fetchAssistantMemory(): Promise<AssistantMemoryNote[]> {
  const response = await fetch(`${apiBaseUrl}/portal/admin/assistant/memory`, {
    headers: await authHeaders(),
  })
  if (!response.ok) {
    throw new Error(`Could not load memory (${response.status})`)
  }
  const body = (await response.json()) as { notes?: AssistantMemoryNote[] }
  return Array.isArray(body.notes) ? body.notes : []
}

export async function resetAssistantMemory(): Promise<void> {
  const response = await fetch(`${apiBaseUrl}/portal/admin/assistant/memory`, {
    method: 'DELETE',
    headers: await authHeaders(),
  })
  if (!response.ok) {
    throw new Error(`Could not reset memory (${response.status})`)
  }
}

export async function deleteAssistantMemory(id: string): Promise<void> {
  const response = await fetch(
    `${apiBaseUrl}/portal/admin/assistant/memory/${encodeURIComponent(id)}`,
    {
      method: 'DELETE',
      headers: await authHeaders(),
    },
  )
  if (!response.ok) {
    throw new Error(`Could not delete memory (${response.status})`)
  }
}
